import type { SpriteDefinition } from '@/render/spriteBaker';
import { PALETTE } from '@/sprites/palette';

/**
 * The Hollow Root, 32x32.
 *
 * Twice the size of everything else down there, because the first thing a
 * boss has to communicate is that it is not another moth. Built from the same
 * palette as the foliage above ground — it is the blight the farm has been
 * dealing with all along, grown into something that grew back.
 */
const HOLLOW_ROOT: string[] = [
  '................................',
  '................................',
  '..........NNNNNNNNNNNN..........',
  '........NNNNNNNNNNNNNNNN........',
  '......NNNNNNNNNNNNNNNNNNNN......',
  '.....NNNNNNNNNNNNNNNNNNNNNN.....',
  '....NNNNNNNNNNNNNNNNNNNNNNNN....',
  '...NNNNNNNNNNNNNNNNNNNNNNNNNN...',
  '...NNNNNNNNeeeeNNNNeeeeNNNNNN...',
  '..NNNNNNNNeeeeeeNNeeeeeeNNNNNN..',
  '..NNNNNNNNeezzeeNNeezzeeNNNNNN..',
  '..NNNNNNNNeeeeeeNNeeeeeeNNNNNN..',
  '..NNNNNNNNNeeeeNNNNeeeeNNNNNNN..',
  '..NNNNNNNNNNNNNNNNNNNNNNNNNNNN..',
  '..NNNNNNNNNNNNNNNNNNNNNNNNNNNN..',
  '..NNNNNNNNNNmmmmmmmmNNNNNNNNNN..',
  '..NNNNNNNNmmMMMMMMMMmmNNNNNNNN..',
  '..NNNNNNNNmMMeeeeeeMMmNNNNNNNN..',
  '..NNNNNNNNmMeeeeeeeeMmNNNNNNNN..',
  '..NNNNNNNNmMMeeeeeeMMmNNNNNNNN..',
  '...NNNNNNNNmmMMMMMMmmNNNNNNNN...',
  '...NNNNNNNNNNmmmmmmNNNNNNNNNN...',
  '....NNNNNNNNNNNNNNNNNNNNNNNN....',
  '.....NNNNNNNNNNNNNNNNNNNNNN.....',
  '......NNNNNNNNNNNNNNNNNNNN......',
  '.......NNNNNNNNNNNNNNNNNN.......',
  '......mmNNNNNNNNNNNNNNNNmm......',
  '.....mMMmmNNNNNNNNNNNNmmMMm.....',
  '....mMMMMMmmNNNNNNNNmmMMMMMm....',
  '...mMMMMMMMMmmmmmmmmMMMMMMMMm...',
  '..mMMMMMMMMMMMMMMMMMMMMMMMMMMm..',
  '................................',
];

export const BOSS_SPRITES = {
  hollowRoot: { name: 'boss-hollow-root', rows: HOLLOW_ROOT, palette: PALETTE },
} as const satisfies Record<string, SpriteDefinition>;

export type BossSpriteKey = keyof typeof BOSS_SPRITES;
